import { PermanentAgent } from '@app/models';

export class PermanentAgentItem {
    id: number;   
    name: string; 
    planningRate7Days: number; 
    planningRate15Days: number; 

    static FromPermanentAgent(o: PermanentAgent): PermanentAgentItem{
        let permanentPeopleItem = new PermanentAgentItem();
        permanentPeopleItem.id = o.id;
        permanentPeopleItem.name = o.name;
        permanentPeopleItem.planningRate7Days = o.planningRate7Days;
        permanentPeopleItem.planningRate15Days = o.planningRate15Days;
        return permanentPeopleItem;
    }      
}

